import * as React from 'react';
import { useSelector } from 'react-redux';

import { useScrollRef } from './hooks';
import { ChatWindowLayout } from '../../components/ChatWindowLayout';
import { currentOpenChatSelector, hostTypeSelector } from '../../selectors';
import { ERequestApiStatus } from '../../types/appState';
import { EHostType } from '../../types/hostType';
import { useApplicationContext } from '../../utils/applicationContext';
import { ChatHeaderPinFilterContainer } from '../ChatHeaderPinFilterContainer';
import { ChatHeaderOfferContainer } from '../ChatHeaderOfferContainer';
import { ChatHeaderUserContainer } from '../ChatHeaderUserContainer';
import { ChatScrollContainer } from '../ChatScrollContainer';
import { ChatWindowErrorContainer } from '../ChatWindowErrorContainer';
import { ChatWindowInitialContainer } from '../ChatWindowInitialContainer';
import { FullscreenGallery } from '../FullscreenGallery';
import { MessageInputFieldContainer } from '../MessageInputFieldContainer';
import { ScammerAlertContainer } from '../ScammerAlertContainer';
import { UnlockChatButtonContainer } from '../UnlockChatButtonContainer';
import { CHATBOT_ID } from '../../constants/chatbotId';
import { OfferMessageTooltipProvider } from '../OfferMessageContainer/provider';

export const ChatWindowContainer: React.FC = () => {
  const currentChat = useSelector(currentOpenChatSelector);
  const hostType = useSelector(hostTypeSelector);

  const { config } = useApplicationContext();

  const status = currentChat ? currentChat.status : ERequestApiStatus.Initial;
  const isChatbot = currentChat?.chatId === CHATBOT_ID;
  const backgroundImageUrl = config.get<string>('frontend-chats.backgroundImage');
  const { scrollRef, scrollToBottom, onScrollHeightChange } = useScrollRef();
  const rootElementRef = React.useRef<HTMLDivElement | null>(null);

  if (status === ERequestApiStatus.Initial && hostType !== EHostType.Frame) {
    return <ChatWindowInitialContainer />;
  }

  return (
    <OfferMessageTooltipProvider rootRef={rootElementRef}>
      <ChatWindowLayout
        backgroundImageUrl={backgroundImageUrl}
        headerNode={
          <>
            <FullscreenGallery />
            <ScammerAlertContainer />
            <ChatHeaderUserContainer />
            {isChatbot && <ChatHeaderPinFilterContainer />}
            <ChatHeaderOfferContainer />
            <ChatWindowErrorContainer />
          </>
        }
        bodyNode={
          <ChatScrollContainer scrollRef={scrollRef} scrollToBottom={scrollToBottom} rootRef={rootElementRef} />
        }
        footerNode={
          <>
            <UnlockChatButtonContainer />
            <MessageInputFieldContainer onHeightChange={onScrollHeightChange} />
          </>
        }
      />
    </OfferMessageTooltipProvider>
  );
};
